import { render, staticRenderFns } from "./camodetail.vue?vue&type=template&id=4fe896c2&scoped=true&"
import script from "./camodetail.vue?vue&type=script&lang=js&"
export * from "./camodetail.vue?vue&type=script&lang=js&"
import style0 from "./camodetail.vue?vue&type=style&index=0&id=4fe896c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe896c2",
  null
  
)

export default component.exports